<form
  class="filters-bar flex-grid filter-forms"
  [class.filter-forms-v2]="isDetailPageEnabled"
  [ngClass]="isDownloadReportList() ? 'is-download-report-list' : ''"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  >
  @if (addBackLink() || backLinkRoute()?.length) {
    <div class="back-arrow" (click)="backArrow()">
      <a miq-go-back-link></a>
    </div>
  }
  @for (props of filters; track props) {
    @if (props.type !== filterInputTypeEnum.SearchBar || !isDetailPageEnabled || isReportsUrl) {
    <div [class]="props.css || 'col'">
      @switch (props.type) {
        @case (filterInputTypeEnum.Select) {
          <miq-simple-select
            [props]="props"
            [value]="props.value"
            [emitKeyField]="type() === filterTypes.availFromTim && props.isDynamic"
            [optionsEndpoint]="props.optionsEndpoint"
            [disabled]="disableAll() || props.disabled"
            (selection)="emitChangeAndPatchForm($event)"
          ></miq-simple-select>
        }
        @case (filterInputTypeEnum.PeriodRange) {
          <miq-period-range
            [props]="props"
            [value]="periodRangeValue"
            [marketQtd]="marketQtdValue"
            [maxValue]="maxValue"
            [reportId]="reportId"
            [reportType]="reportType()"
            [type]="periodType()"
            (selection)="emitChangeAndPatchForm($event)"
          ></miq-period-range>
        }
        @case (filterInputTypeEnum.MultiSelect) {
          @if (props.searchableMultiSelect) {
            <miq-searchable-multi-select
              [props]="props"
              [value]="props.value"
              [multi]="true"
              [disabled]="disableAll() || props.isDisabled"
              (selection)="emitChangeAndPatchForm($event)"
            ></miq-searchable-multi-select>
          } @else {
            <miq-simple-select
              [props]="props"
              [value]="props.value"
              [multi]="true"
              [emitKeyField]="type() === filterTypes.availFromTim && props.isDynamic"
              [optionsEndpoint]="props.optionsEndpoint"
              [disabled]="disableAll() || props.isDisabled"
              (selection)="emitChangeAndPatchForm($event)"
            ></miq-simple-select>
          }
        }
        @case (filterInputTypeEnum.Range) {
          @if (CENumberFormat) {
            <miq-ce-range-item
              class="forms-container"
              [filter]="props"
              [form]="form"
              [tabInfo]="tabInfo"
              [emitKeyField]="type() === filterTypes.availFromTim"
              (rangeChange)="emitChangeAndPatchForm($event)"
            ></miq-ce-range-item>
          } @else {
            <miq-range-item
              class="forms-container"
              [filter]="props"
              [form]="form"
              [tabInfo]="tabInfo"
              [emitKeyField]="type() === filterTypes.availFromTim"
              (rangeChange)="emitChangeAndPatchForm($event)"
            ></miq-range-item>
          }
        }
        @case (filterInputTypeEnum.EqualNoCase) {
          <miq-equals-filter
            [props]="props"
            [emitKeyField]="type() === filterTypes.availFromTim && props.isDynamic"
            (search)="emitChangeAndPatchForm($event)"
          ></miq-equals-filter>
        }
        @case (filterInputTypeEnum.Equal) {
          <miq-equals-filter
            [props]="props"
            [emitKeyField]="type() === filterTypes.availFromTim && props.isDynamic"
            (search)="emitChangeAndPatchForm($event)"
          ></miq-equals-filter>
        }
        @case (filterInputTypeEnum.Text) {
          <miq-equals-filter
            [props]="props"
            [emitKeyField]="type() === filterTypes.availFromTim && props.isDynamic"
            (search)="emitChangeAndPatchForm($event)"
          ></miq-equals-filter>
        }
        @case (filterInputTypeEnum.ClearValues) {
          <div [ngClass]="props.css">
            <a (click)="clearFilters.emit()" id="clearfilter">{{ 'recordsSearch.clearValues' | translate| uppercase }}</a>
          </div>
        }
        @case ('separator') { 
          <span [class.divider]="!isDetailPageEnabled"></span>
        }
        @case (filterInputTypeEnum.SearchBar) {
          @if (!isDetailPageEnabled || isReportsUrl) {
          <miq-search-bar
            [searchValue]="props.value"
            [props]="props"
            (search)="emitChangeAndPatchForm($event)"
          ></miq-search-bar>
        }
        }
        @case (filterInputTypeEnum.AutoCompleteBar) {
          <miq-auto-complete-bar
            [searchValue]="props.value"
            [props]="props"
            (search)="emitChangeAndPatchForm($event)"
            >
          </miq-auto-complete-bar>
        }
        @case (filterInputTypeEnum.Button) {
          <button class="btn-submit-100" type="submit">Update</button>
        }
      }
    </div>
    }
  }
</form>
<!-- visible this section only for searchMatchingAvailability From Tim-->
@if (type() === 'searchAvailFromTim') {
  <div class="filter-actions">
    <a id="addfilters" (click)="openFiltersDialog('availability')">
      {{ 'recordsSearch.addFilters' | translate| titlecase }}</a
      >
      <a (click)="onClearFilters()" id="clearfilter"> {{ 'recordsSearch.clearValues' | translate| titlecase }}</a>
      <a (click)="onResetFilters()" id="resetfilter"> {{ 'recordsSearch.resetFilters' | translate| titlecase }}</a>
    </div>
  }
